import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { EquiposTypes } from "../../app/types/genericTables.types";

type UseEquipmentType = {
  equipmentList: EquiposTypes[];
  get: (id: EquiposTypes["id"]) => EquiposTypes | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useEquipment = create<UseEquipmentType>((set, get) => ({
  loading: false,
  equipmentList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) => get().equipmentList.find((equipment) => equipment.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/Equipos";
      const { data: response } = await getData(endpoint);
      set(() => ({
        equipmentList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching analysisTypeList:", error);
      set({ loading: false });
    }
  },
}));
